type TClusterSymbol = {
  canvas: HTMLCanvasElement;
  pos: { x: number; y: number };
};

const SYMBOL_BG_COLOR = "220,0,50";

const clusterBgCache = {};
const clusterIconCache = {};

const createClusterBgCanvas = (size: number) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d")!;
  canvas.width = size;
  canvas.height = size;
  const cacheKey = `${size}`;

  const cacheData = clusterBgCache[cacheKey];

  if (cacheData) {
    ctx.putImageData(cacheData, 0, 0);
  } else {
    const halfSize = size / 2;
    ctx.beginPath();
    ctx.strokeStyle = `rgba(${SYMBOL_BG_COLOR},0.2)`;
    ctx.fillStyle = `rgba(${SYMBOL_BG_COLOR},1)`;
    ctx.arc(halfSize, halfSize, (halfSize / 5) * 3, 0, 2 * Math.PI, false);
    ctx.fill();
    ctx.lineWidth = (halfSize / 5) * 4;
    ctx.stroke();
    clusterBgCache[cacheKey] = ctx.getImageData(0, 0, size, size);
  }

  return canvas;
};

const getClusterSymbol = (weight: number): TClusterSymbol => {
  if (weight < 10) {
    return {
      canvas: createClusterBgCanvas(28),
      pos: {
        x: 11,
        y: 18,
      },
    };
  }
  if (weight < 25) {
    return {
      canvas: createClusterBgCanvas(38),
      pos: {
        x: 13,
        y: 23,
      },
    };
  }
  if (weight < 50) {
    return {
      canvas: createClusterBgCanvas(38),
      pos: {
        x: 13,
        y: 23,
      },
    };
  }
  if (weight < 100) {
    return {
      canvas: createClusterBgCanvas(38),
      pos: {
        x: 13,
        y: 23,
      },
    };
  }
  if (weight < 1000) {
    return {
      canvas: createClusterBgCanvas(48),
      pos: {
        x: 15,
        y: 28,
      },
    };
  }
  return {
    canvas: createClusterBgCanvas(66),
    pos: {
      x: 20,
      y: 38,
    },
  };
};

const getClusterIcon = (weight: number): H.map.Icon => {
  const cacheKey = `${weight}`;

  if (clusterIconCache[cacheKey]) {
    return clusterIconCache[cacheKey];
  }

  const { canvas, pos } = getClusterSymbol(weight);

  const ctx = canvas.getContext("2d")!;
  ctx.fillStyle = "#FFFFFF";
  ctx.font = "bold 11px Arial";
  ctx.fillText(weight.toString(), pos.x, pos.y);
  const size = canvas.width;

  const icon = new H.map.Icon(canvas, {
    size: { w: size, h: size },
    anchor: { x: size / 2, y: size / 2 },
    crossOrigin: true,
  });

  clusterIconCache[cacheKey] = icon;

  return icon;
};

export default getClusterIcon;
